/**
 * 磁気偏角（磁北と真北のずれ）。
 *
 * WMM（World Magnetic Model）をバンドル済み係数（geomagnetism パッケージ）
 * から計算する。ネットワーク接続を必要としない — このアプリの
 * オフライン前提の設計方針（オフライン地図・gv-bridge 等）に合わせている。
 *
 * 符号の規約（NOAA/WMM 標準と同じ）:
 *   declinationDeg > 0 → 磁北は真北より東（東偏, easterly）
 *   declinationDeg < 0 → 磁北は真北より西（西偏, westerly）
 *   trueHeading = magneticHeading + declinationDeg (mod 360)
 */

import geomagnetism from 'geomagnetism';

export interface DeclinationResult {
  /** 磁気偏角 [度]。上記の符号規約を参照 */
  declinationDeg: number;
  /** モデル計算に使った日時 [epoch ms] */
  computedAt: number;
}

/** 緯度経度（・任意で日時）から磁気偏角を求める */
export function getMagneticDeclination(lat: number, lon: number, at?: Date): DeclinationResult {
  const date = at ?? new Date();
  const m = geomagnetism.model(date, { allowOutOfBoundsModel: true });
  const point = m.point([lat, lon]);
  return { declinationDeg: point.decl, computedAt: date.getTime() };
}

/** 磁方位 → 真方位。[0,360) に正規化 */
export function magneticToTrueHeading(magneticHeadingDeg: number, declinationDeg: number): number {
  return normalizeDeg(magneticHeadingDeg + declinationDeg);
}

/** 真方位 → 磁方位。[0,360) に正規化 */
export function trueToMagneticHeading(trueHeadingDeg: number, declinationDeg: number): number {
  return normalizeDeg(trueHeadingDeg - declinationDeg);
}

function normalizeDeg(deg: number): number {
  return ((deg % 360) + 360) % 360;
}
